
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay } from "swiper/modules";
import { useState} from "react";
import { pdfjs } from "react-pdf"
import Lightbox from "yet-another-react-lightbox";

import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Download from "yet-another-react-lightbox/plugins/download";

import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";


import { galleries } from "../components/galleryData";


import Header from "../components/header";
import Footer from "../components/footer";


import vission01 from "../assets/images/nestings/Compact-1.webp"
import vission02 from "../assets/images/nestings/Compact-2.webp"
import vission03 from "../assets/images/nestings/Compact-3.webp"
// pdf
import Pdfvilla from "../assets/pdf/ModelvillaViewAll.pdf";

import modalvilla from "../assets/images/Modelvilla1bhkand2bhk.webp"


pdfjs.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

const vissions = [
     {
        src:vission01,
        title:"Elevated Living, Naturally Private",
        sub:"Designed forthose who seek both stunning views and peaceful seclusion,this exclusive plotis surrounded by lush forest layers, ensuring privacy, tranquility, and a deep connection with nature" 

    },
    {
        src:vission02,
        title:"Elevated Living, Naturally Private",
        sub:"Designed forthose who seek both stunning views and peaceful seclusion,this exclusive plotis surrounded by lush forest layers, ensuring privacy, tranquility, and a deep connection with nature" 

    },
    // {   
    //     src:vission03,
    //     title:"A Self-Sustaining Green Sanctuary",
    //     sub:"Each Nesting is a whisper of nature’s poetry, wrapped in a lush embrace of emerald canopies. Here,towering trees stand as silent sentinels,their branches weaving shadows of serenity, theirroots deep in the earth’s quiet song." 
    // },
]




    export default function Nesting() {
    const [open, setOpen] = useState(false);
    const [slides, setSlides] = useState([]);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    const openGallery = (type) => {
    setSlides(galleries[type]);
    setOpen(true);
    };

    const [isOpen, setIsOpen] = useState(false);

    const openPDF = () => {
    setIsOpen(true);
    };

    const closePDF = () => {
    setIsOpen(false);
    };

  
    
    return (
   <div className="dody-container  biome-element-fieldhouse">
    <Header />
    <section>
        <div className="biome biome-24">
            <div className='section-scroll-animation '>
                <div
                    className="biome-element biome-element-d2ebcd8 biome-element-d2ebc99 biome-element-d2ebc99126 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky animate-section-trigger">

                    <div className="e-con-inner">
                        <div className="biome-element biome-element-6ea5a01 e-con-full e-flex e-con e-child">

                            <div
                                className="biome-element biome-element-87b503c biome-widget biome-widget-elementskit-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <div className="ekit-wid-con">
                                        <div
                                            className="ekit-heading elementskit-section-title-wraper text_center   ekit_heading_tablet-   ekit_heading_mobile-text_center">
                                            <h1 data-anim="rotate"
                                                className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                                Homes That Belong to the Land
                                            </h1>
                                            <p data-anim="fade-up"
                                                className="attr-h3 attr-text-white title-anim gsap-text">
                                                At <b>Biome</b>, every structure begins with a deep
                                                respect for the land. Construction materials are thoughtfully chosen to reflect the
                                                textures and tones of the forest sourced locally, built to last, and
                                                designed to age with grace. Rammed earth walls, hand made bricks from native
                                                clay, exposed stone, reclaimed wood, and weathered corten steel come
                                                together to form homes that feel grown ratherthan built. These natural,
                                                low impact materials not only reduce the environmental footprint, but
                                                also root each dwelling in its surrounding sallowing it to breathe,
                                                blend, and belong. Synthetic surface finishes are avoided entirely, in favor of
                                                those that evolve with time, deepening the connection between
                                                architecture and the forest it calls home.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div
                    className="biome-element biome-element-1447961 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger">
                    <div className="e-con-inner">
                        <div
                            className="biome-element biome-element-b184175 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title ">Earth Integrated
                                            Design</h2>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div
                            className="biome-element biome-element-b184175 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">

                                    <p data-anim="fade-up" className="title-anim gsap-text">Built with stabilised mud
                                        blocks, rammed earth walls, and local stone, nestings use on site materials for
                                        low embodied energy and natural insulation. Courtyards and shaded verandahs
                                        create micro climates, while green roofs blend roofs into the surrounding canopy,
                                        supporting biodiversity and cooling the interiors.</p>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element biome-element-e375d20 e-con-full e-flex e-con e-child">
                            <div
                                className="biome-element biome-element-3012ab4 e-con-full e-flex e-con e-child animated fadeInUp">
                                <div className="biome-element biome-element-350d2ce biome-widget biome-widget-heading">
                                    <div className="biome-widget-container">
                                        {/* <h4 className="biome-heading-title biome-size-default">Early Bird Discount
                                        </h4> */}
                                    </div>
                                </div>
                                <div
                                    className="biome-element biome-element-f151e20 biome-view-framed biome-position-right biome-mobile-position-right biome-tablet-position-top biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-box-wrapper">

                                       

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="biome-element biome-element-d812d61 e-con-full e-flex e-con e-child animated fadeInUp">
                                <div className="biome-element biome-element-7f4045a biome-widget biome-widget-heading">
                                    <div className="biome-widget-container">
                                        {/* <h4 className="biome-heading-title biome-size-default">Weekend Escape Deal
                                        </h4> */}
                                    </div>
                                </div>
                                <div
                                    className="biome-element biome-element-051b5bf biome-view-framed biome-position-right biome-mobile-position-right biome-tablet-position-top biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-box-wrapper">

                                       

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="biome-element biome-element-acbd445 e-con-full e-flex e-con e-child animated fadeInUp">
                                <div className="biome-element biome-element-82d56a7 biome-widget biome-widget-heading">
                                    <div className="biome-widget-container">
                                       
                                    </div>
                                </div>
                                <div
                                    className="biome-element biome-element-b1a93d1 biome-view-framed biome-position-right biome-mobile-position-right biome-tablet-position-top biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-box-wrapper">


                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="biome-element biome-element-cb18362 e-con-full e-flex e-con e-child animated fadeInUp">
                                <div className="biome-element biome-element-50dea03 biome-widget biome-widget-heading">
                                    <div className="biome-widget-container">
                                        {/* <h4 className="biome-heading-title biome-size-default">Nature’s Embrace</h4>
                                        */}
                                    </div>
                                </div>
                                <div
                                    className="biome-element biome-element-0650213 biome-view-framed biome-position-right biome-mobile-position-right biome-tablet-position-top biome-shape-circle biome-widget biome-widget-icon-box">
                                    <div className="biome-widget-container">
                                        <div className="biome-icon-box-wrapper">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

       

      

        <div className="biome biome-687 animate-section-trigger ">

            <Swiper modules={[EffectFade, Autoplay]} effect="fade" fadeEffect={{ crossFade: true }}
                autoplay={{ delay: 2500 }} loop={true} speed={800} className="mySwiper">
                {vissions.map((vission, i) => (
                <SwiperSlide>
                    <div
                        className="biome-element biome-element-4fcb1b1 e-flex e-con-boxed e-con e-parent e-lazyloaded horizontal-container-panel">

                        <div className="biome-background-slideshow">

                            <div className="biome-background-slideshow__slide">
                                <div className="biome-background-slideshow__slide__image biome-ken-burns biome-ken-burns--in"
                                    style={{ backgroundImage: `url(${vission.src})` }}>
                                </div>
                            </div>

                        </div>

                        <div className="e-con-inner  section-scroll-animation">
                            <div
                                className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading animated fadeInUp">
                                <div className="biome-widget-container">
                                    <h2 data-anim="rotate" className="biome-heading-title biome-size-default">
                                        {vission.title}</h2>
                                </div>
                            </div>
                            <div className="biome-element biome-element-48776fe e-con-full e-flex e-con e-child"
                                data-id="48776fe" data-element_type="container">
                                <div
                                    className="biome-element biome-element-b750a21 biome-widget__width-initial biome-widget-mobile__width-inherit biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className='title-anim gsap-text attr-text-white'>
                                            {vission.sub}
                                        </p>
                                     
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                ))}

            </Swiper>
                <div className='modal-fix-select'>
                    <div className="biome-element biome-element-0e4df59 biome-widget biome-widget-heading">
                        <div className="biome-widget-container">
                            <h2 data-anim="rotate" className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">Model villa</h2>
                        </div>
                    </div>
                    <button className="modal-villa-btn" onClick={()=> openGallery("twoBhk")}>
                        2BHK Model (1630 qft.) <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                            fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg>
                    </button>

                    <button className="modal-villa-btn" onClick={()=> openGallery("threeBhk")}>
                        3BHK Model (1930 qft.) <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30"
                            fill="currentColor" class="bi bi-arrow-right" viewBox="0 0 16 16">
                            <path fill-rule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                        </svg>
                    </button>
                    <button className="modal-villa-btn" onClick={()=> openPDF()}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor"
                            class="bi bi-file-earmark-pdf-fill" viewBox="0 0 16 16">
                            <path
                                d="M5.523 12.424q.21-.124.459-.238a8 8 0 0 1-.45.606c-.28.337-.498.516-.635.572l-.035.012a.3.3 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548m2.455-1.647q-.178.037-.356.078a21 21 0 0 0 .5-1.05 12 12 0 0 0 .51.858q-.326.048-.654.114m2.525.939a4 4 0 0 1-.435-.41q.344.007.612.054c.317.057.466.147.518.209a.1.1 0 0 1 .026.064.44.44 0 0 1-.06.2.3.3 0 0 1-.094.124.1.1 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256M8.278 6.97c-.04.244-.108.524-.2.829a5 5 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.5.5 0 0 1 .145-.04c.013.03.028.092.032.198q.008.183-.038.465z" />
                            <path fill-rule="evenodd"
                                d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.7 11.7 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.86.86 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.84.84 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.8 5.8 0 0 0-1.335-.05 11 11 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.24 1.24 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a20 20 0 0 1-1.062 2.227 7.7 7.7 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103" />
                        </svg> View All PDF
                    </button>

                    {/* Download PDF (direct link) */}
                    <a className="modal-villa-btn download-btn" href={Pdfvilla} download="ModelvillaViewAll.pdf" aria-label="Download Model Villa PDF">
                        <button><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" className="icon-download" focusable="false" aria-hidden="true">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg> Download PDF</button>
                    </a>
                </div>
            <div
                className="biome-element biome-element-03b44c8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-bg-white animate-section-trigger">
                <div className="e-con-inner">
                    <div className="biome-element biome-element-c3ca9d9 e-con-full e-flex e-con e-child">
                       
                        <div
                            className="biome-element biome-element-e67a910 biome-widget biome-widget-elementskit-heading animated fadeInUp">
                            <div className="biome-widget-container">
                                <div className="ekit-wid-con">
                                    <div
                                        className="ekit-heading elementskit-section-title-wraper text_left   ekit_heading_tablet-   ekit_heading_mobile-">
                                        <h2 data-anim="rotate"
                                            className="ekit-heading--title elementskit-section-title  animation__char_come gsap-text ">
                                            Self Sustaining Green Sancutuary</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="biome-element biome-element-f233ff6 e-con-full e-flex e-con e-child">
                            <div className="biome-element biome-element-bf22355 e-con-full e-flex e-con e-child">
                                <div
                                    className="biome-element biome-element-7637ce7 biome-widget biome-widget-text-editor animated fadeInUp">
                                    <div className="biome-widget-container">
                                        <p data-anim="fade-up" className="title-anim gsap-text">
                                          Each FIELD HOUSE is a whisper of nature’s poetry, wrapped in a lush embrace of emerald canopies. Here, towering trees stand as silent sentinels, their branches weaving shadows of serenity, their roots deep in the earth’s quiet song. A tapestry of mango, tamarind, jamun, wood apple, and jackfruit forms a living boundary, not just shielding but nurturing a FIELD HOUSE where privacy blooms and the land give endlessly. Fruits ripen in golden sunlight, leaves dance in the wind’s gentle hymn, and the earth hums with life a place where nature, solitude, and abundance become one.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        
                        </div>
                    </div>

                    <div
                        className="biome-element biome-element-d2ebcd8 e-flex e-con-boxed e-con e-parent e-lazyloaded biome-kit-5-sticky first-story-section">

                        <iframe src="https://www.youtube.com/embed/PkxkaU-F7Rc?autoplay=1&mute=1&rel=0"
                            title="YouTube video player" style={{
                                width: "100%",
                                height: "100vh",
                                border: 0,
                                }}
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen></iframe>
                    </div>

                </div>

            </div>

        </div>

        <Lightbox open={open} close={()=> setOpen(false)}
            slides={slides}
            plugins={[Zoom, Fullscreen, Thumbnails, Slideshow, Captions, Download]}
            captions={{
                    showToggle: false,   
                    descriptionTextAlign: "center",
                }}
                            zoom={{
                    maxZoomPixelRatio: 3,
                    zoomInMultiplier: 2,
                }}
                            thumbnails={{
                    position: "bottom",
                    width: 120,
                    height: 80,
                }}
                        index={lightboxIndex}
                        controller={{
                                on: {
                                        change: (idx) => setLightboxIndex(idx),
                                },
                        }}
            />

            {/* ===== PDF MODAL ===== */}
            {isOpen && (
            <div className="pdf-backdrop" onClick={closePDF}>
                <button className="close-btn" onClick={closePDF}>✕</button>

                <div className="pdf-modal" onClick={(e)=> e.stopPropagation()}
                    onContextMenu={(e) => e.preventDefault()}
                    >
                    <h3>Model Villa</h3>

                    <iframe src={`${Pdfvilla}#toolbar=0&navpanes=0&scrollbar=0&statusbar=0&view=FitH`}
                        title="PDF Modal Villa" width="100%" height="100%" style={{ border: "none"}} />

                </div>
            </div>
            )}

    </section>
    <Footer />
</div>
)}